import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { Typography } from "~/ui-kit/components/Typography/Typography";

export type ReturnsPolicyProps = {
  url: string;
};

export const ReturnsPolicy: FC<ReturnsPolicyProps> = ({ url }) => {
  const { t } = useTranslation();
  return (
    <Typography
      size="sm"
      weight="md"
      className="grey-900-c cursor-pointer"
      onClick={() => window.open(url)}
    >
      {t("backend:returns_policy")}
    </Typography>
  );
};
